const bodyOverflowDisableClass = 'disable-overflow';

export const addBodyClass = (className: string) => {
  document.body.classList.add(className);
};

export const removeBodyClass = (className: string) => {
  if (document.body.classList.contains(className)) {
    document.body.classList.remove(className);
  }
};

export const disableBodyOverflow = (): void => {
  addBodyClass(bodyOverflowDisableClass);
};

export const enableBodyOverflow = (): void => {
  removeBodyClass(bodyOverflowDisableClass);
};
